import React, { useEffect, useState, lazy } from 'react';
import { Row, Col } from 'src/componentes/grid';
import { useIntl } from 'react-intl';

import Schema from './Schema';

import Input from 'src/componentes/input';
import Edit from 'src/componentes/edit/edit-dialog';
import DatePicker from 'src/componentes/date-picker';
import ColaboradorLookup from 'src/lookups/colaborador';
import CausasEventoRisco from '../CausasEventoRisco';
import ConsequenciasEventoRisco from '../ConsequenciasEventoRisco';
import PanelCollapse from 'src/componentes/panel-collapse';
import Info from 'src/componentes/info';
import SeveridadeRiscoLookup from 'src/lookups/severidade-risco';
import InputNumber from 'src/componentes/input-number';
import { capitalizeFirstLetter, lowerCaseAllLetter } from 'src/utils/string';
import RespostaOcorrenciaLookup from 'src/lookups/RespostaOcorrenciaLookup';
import useAuth from 'src/hooks/useAuth';
import ArquivoUploadAnexos from 'src/componentes/arquivo-upload/anexos';
import PlanoContingenciaLookup from 'src/lookups/PlanoContingenciaLookup';
import AcaoView from 'src/paginas/acao';
import http from 'src/services/httpService';
import { getConfiguration } from 'src/services/commonRequests';
import LoadingContainer from 'src/componentes/loading-container';
import ContentManager from 'src/componentes/content-manager';
import Confirm from 'src/componentes/message-box/confirm';
import { ENTIDADE_ANEXOS } from 'src/utils/constants';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';
import ComunicadoEventoRisco from '../ComunicadoEventoRisco';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import Reuniao from 'src/paginas/reuniao';
import { toBoolean } from 'src/utils/boolean';
const Historico = lazy(() => import('src/paginas/versao-alteracao'));

function FormEdit({
  model,
  configuracao,
  configuracaoRisco,
  parameters,
}) {
  const { terms: resources } = useAuth();
  const [isLoadingAcoes, setIsLoadingAcoes] = useState(false);
  const [tiposSeveridade, setTiposSeveridades] = useState(null);
  const [itensLookupSeveridade, setItensLookupSeveridade] = useState([]);
  const [descricoesTipos, setDescricoesTipos] = useState(null);
  const [isLoadingSeveridade, setIsLoadingSeveridade] = useState(false);
  const intl = useIntl();
  const severidadeModelName = 'valoresTipoSeveridade';
  const infoSeveridadeName = 'infoTipoSeveridadeDescricaoEvento';
  let generatedNumbers = [];

  const isDisabled = model.getModel('permissions').value
    ? !model.getModel('permissions').value.allowEdit
    : false;
  const isNew = model?.getModel('id')?.value < 1;
  const utilizarCodigoAutomaticoEventoRisco = toBoolean(
    configuracao?.utilizarCodigoAutomatico
  );
  const permitirAlterarCodigoAutomaticoEventoRisco = toBoolean(
    configuracao?.permitirAlterarCodigoAutomatico
  );
  const criarPlanoDeAcaoRespostaOcorrencia = toBoolean(
    configuracao?.criarPlanoDeAcaoRespostaOcorrencia
  );
  const habilitarPlanoContigencia = toBoolean(
    configuracaoRisco?.habilitarPlanoContigencia
  );
  const tornarDefinicaoPlanoDeAcaoObrigatoria = toBoolean(
    configuracao?.tornarDefinicaoPlanoDeAcaoObrigatoria
  );
  const exibirSecaoPlanoAcao =
    criarPlanoDeAcaoRespostaOcorrencia || habilitarPlanoContigencia;
  const exibirIdIntegracao = !isNew || !utilizarCodigoAutomaticoEventoRisco;

  useEffect(() => {
    const modelUtilizarCodigoAutomaticoEventoRisco = model?.getModel(
      'utilizarCodigoAutomatico'
    );
    const modelPermitirAlterarCodigoAutomaticoEventoRisco = model?.getModel(
      'permitirAlterarCodigoAutomatico'
    );

    if (
      modelUtilizarCodigoAutomaticoEventoRisco &&
      modelUtilizarCodigoAutomaticoEventoRisco.value !==
        utilizarCodigoAutomaticoEventoRisco
    ) {
      modelUtilizarCodigoAutomaticoEventoRisco.requestChange(
        utilizarCodigoAutomaticoEventoRisco
      );
    }

    if (
      modelPermitirAlterarCodigoAutomaticoEventoRisco &&
      modelPermitirAlterarCodigoAutomaticoEventoRisco.value !==
        permitirAlterarCodigoAutomaticoEventoRisco
    ) {
      modelPermitirAlterarCodigoAutomaticoEventoRisco.requestChange(
        permitirAlterarCodigoAutomaticoEventoRisco
      );
    }

    const modelCriarPlanoDeAcaoRespostaOcorrencia = model?.getModel(
      'criarPlanoDeAcaoRespostaOcorrencia'
    );
    const modelTornarDefinicaoPlanoDeAcaoObrigatoria = model?.getModel(
      'tornarDefinicaoPlanoDeAcaoObrigatoria'
    );

    if (
      modelCriarPlanoDeAcaoRespostaOcorrencia &&
      modelCriarPlanoDeAcaoRespostaOcorrencia.value !==
        criarPlanoDeAcaoRespostaOcorrencia
    ) {
      modelCriarPlanoDeAcaoRespostaOcorrencia.requestChange(
        criarPlanoDeAcaoRespostaOcorrencia
      );
    }

    if (
      modelTornarDefinicaoPlanoDeAcaoObrigatoria &&
      modelTornarDefinicaoPlanoDeAcaoObrigatoria.value !==
        tornarDefinicaoPlanoDeAcaoObrigatoria
    ) {
      modelTornarDefinicaoPlanoDeAcaoObrigatoria.requestChange(
        tornarDefinicaoPlanoDeAcaoObrigatoria
      );
    }
  }, [
    model,
    utilizarCodigoAutomaticoEventoRisco,
    permitirAlterarCodigoAutomaticoEventoRisco,
    criarPlanoDeAcaoRespostaOcorrencia,
    tornarDefinicaoPlanoDeAcaoObrigatoria,
  ]);

  const getColumnsSeveridade = async () => {
    setIsLoadingSeveridade(true);
    try {
      const response = await http.post(`/TipoSeveridade/List`, {
        parameters: { buscarExcluidos: true },
        pageSize: 1000,
      });
      setTiposSeveridades(response.data.list);
    } catch {
      setTiposSeveridades([]);
    } finally {
      setIsLoadingSeveridade(false);
    }
  };

  useEffect(() => {
    if (configuracao?.avaliarSeveridadePorTipo) getColumnsSeveridade();
  }, [configuracao]);

  const getValueSeveridade = (item, tipo) => {
    if (item === severidadeModelName) {
      const tipoSeveridadeValue = model.getModel(item).value;
      const result = tipoSeveridadeValue?.find(
        (valor) => valor.tipoSeveridade.id == tipo.id
      );
      return result?.severidade;
    } else {
      return model.getModel(item).value;
    }
  };

  const requestChangeSeveridade = (value, tipo) => {
    const currentModel = model.getModel(severidadeModelName);
    let valores = currentModel.value;
    if (!valores) valores = [];

    const itemValor = valores.find((item) => item.tipoSeveridade.id == tipo.id);
    if (itemValor) {
      itemValor.severidade = value;
    } else {
      valores.push({ severidade: value, tipoSeveridade: tipo });
    }
    currentModel.requestChange(valores);
  };

  const renderDescricaoArraySeveridade = (tipo) => {
    const infos = descricoesTipos?.filter(
      (item) => item.tipoSeveridade.id == tipo.id && item.descricao
    );
    if (infos && infos.length > 0) {
      return (
        <table>
          <tbody>
            {infos.map((obj) => (
              <tr key={`${tipo.id}-${obj.nomeSeveridade}`}>
                <td style={{ fontWeight: 'bold' }}>{obj.nomeSeveridade}:</td>
                <td style={{ textAlign: 'left' }}>{obj.descricao}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    } else {
      return (
        <table>
          <tbody>
            <tr>
              <td style={{ fontWeight: 'bold' }}>
                {intl.formatMessage({ id: 'labelNenhumDescricaoInformada' })}
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  const loadDescricoesSeveridade = () => {
    http
      .post(`TipoSeveridadeDescricao/ObterDescricoes`)
      .then((response) => {
        setDescricoesTipos(response.data);
      })
      .catch(() => {
        setDescricoesTipos([]);
      });
  };

  const loadItensLookupSeveridade = () => {
    const data = {
      idsSelecionados: model.getModel('listaSeveridadeIdMatriz')?.value,
    };
    http
      .post(`SeveridadeRiscoLookup/Search`, { filter: data, pageSize: 1000 })
      .then((response) => {
        setItensLookupSeveridade(response.data.list);
      })
      .catch(() => {
        setItensLookupSeveridade([]);
      });
  };

  useEffect(() => {
    loadDescricoesSeveridade();
  }, []);

  useEffect(() => {
    loadItensLookupSeveridade();
  }, [model.getModel('listaSeveridadeIdMatriz')?.value]);

  function handleSaveCausaRisco(item, handleClose) {
    const modelCausa = model.getModel('causas');
    let itens = modelCausa.value;
    if (!itens) itens = [];

    if (!itens?.find((x) => x.causa.id == item.causa.id)) {
      let causa = {
        id: -1,
        descricao: item.causa.descricao,
        causa: item.causa,
        permissions: { allowDelete: true, allowEdit: true },
      };
      itens.push(causa);
    }

    modelCausa.requestChange(itens);

    handleClose();
  }

  function handleDeleteCausaRisco(item) {
    const modelCausa = model.getModel('causas');
    let itens = modelCausa.value;

    const index =
      itens && itens.findIndex((prop) => prop.causa.id === item.causa.id);

    if (index != -1) {
      itens.splice(index, 1);
      modelCausa.requestChange(itens);
    }
  }

  function afterRemove(item) {
    const modelAcoes = model.getModel('acoes');
    let itens = modelAcoes.value;
    const index = itens && itens.findIndex((prop) => prop.id === item.id);

    if (index != -1) {
      itens.splice(index, 1);
      modelAcoes.requestChange(itens);
    }
  }

  function handleVincularAcaoSucesso(novaAcao) {
    if (!novaAcao) return;

    const modelAcoes = model.getModel('acoes');
    let itens = modelAcoes.value;
    if (!itens) itens = [];

    if (!itens.find((x) => x.id === novaAcao.id)) {
      const nomeItem =
        novaAcao.nomeItem ??
        novaAcao.item?.nome ??
        model.getModel('risco')?.value?.nome;
      const acaoComItem = { ...novaAcao, nomeItem };
      itens.push({ ...acaoComItem, editModel: { ...acaoComItem } });
    }

    modelAcoes.requestChange(itens);
  }

  function handleChange(item, handleCloseCallBack) {
    const modelAcoes = model.getModel('acoes');
    let itens = modelAcoes.value;
    if (!itens) itens = [];

    if (!itens.find((x) => x.id == item.id)) {
      let randomNumber;
      do {
        randomNumber = (Math.floor(Math.random() * 1000) + 1) * -1;
      } while (generatedNumbers.includes(randomNumber));

      generatedNumbers = [...generatedNumbers, randomNumber];
      const newItem = {
        ...item,
        id: randomNumber,
        editModel: { ...item, id: randomNumber },
      };
      itens.push(newItem);
    } else {
      itens = itens.map((v) => {
        if (v.id === item.id) {
          return { ...item, editModel: item };
        }
        return v;
      });
    }
    modelAcoes.requestChange(itens);
    handleCloseCallBack();
  }

  function handleChangeComunicado(item, handleCloseCallBack) {
    const modelComunicados = model.getModel('comunicados');
    let itens = modelComunicados.value;
    if (!itens) itens = [];

    if (!itens.find((x) => x.id == item.id)) {
      let randomNumber;
      do {
        randomNumber = (Math.floor(Math.random() * 1000) + 1) * -1;
      } while (generatedNumbers.includes(randomNumber));

      generatedNumbers = [...generatedNumbers, randomNumber];
      const newItem = {
        ...item,
        id: randomNumber,
        editModel: { ...item, id: randomNumber },
      };
      itens.push(newItem);
    } else {
      itens = itens.map((v) => {
        if (v.id === item.id) {
          return { ...item, editModel: item };
        }
        return v;
      });
    }
    modelComunicados.requestChange(itens);
    handleCloseCallBack();
  }

  function handleDeleteComunicado(item) {
    const modelComunicados = model.getModel('comunicados');
    let itens = modelComunicados.value;

    const index = itens && itens.findIndex((prop) => prop.id === item.id);

    if (index != -1) {
      itens.splice(index, 1);
      modelComunicados.requestChange(itens);
    }
  }

  function findMissingIds(array1, array2) {
    return array1.filter((id) => !array2.includes(id));
  }

  function handleDeleteConsequenciaRisco(item) {
    const modelConsequencia = model.getModel('consequencias');
    let itens = modelConsequencia.value;
    const index =
      itens &&
      itens.findIndex((prop) => prop.consequencia.id === item.consequencia.id);

    if (index != -1) {
      itens.splice(index, 1);
      modelConsequencia.requestChange(itens);
    }
  }

  function handleRemovePlanoContingencia(currentValue, newValue) {
    const missingIds = findMissingIds(currentValue, newValue);
    const itens = model.getModel('acoes').value;
    const newItens = itens.filter(
      (a) =>
        !a.planoContingenciaId ||
        !missingIds.some((v) => v.id === a.planoContingenciaId)
    );
    model.getModel('acoes').requestChange(newItens);
    model.getModel('planosContingencia').requestChange(newValue);
    setIsLoadingAcoes(false);
  }

  function requestChangePlanoContingencia(value) {
    setIsLoadingAcoes(true);

    const newValue = value;
    const currentValue = model.getModel('planosContingencia').value;

    if (newValue.length < currentValue.length) {
      ContentManager.addContent(
        <Confirm
          message={capitalizeFirstLetter(
            intl.formatMessage(
              { id: 'msgValidacaoRemoverPlanoContingenciaEventoRisco' },
              { acoes: lowerCaseAllLetter(resources.acoes) }
            )
          )}
          handleConfirm={() =>
            handleRemovePlanoContingencia(currentValue, newValue)
          }
        />
      );

      setIsLoadingAcoes(false);
    } else {
      http
        .post('/eventoRisco/ObterAcoesPlanoContingencia', {
          idPlano: value.map((obj) => obj.id),
          eventoRiscoId: model?.getModel('id')?.value,
          dataOcorrencia: model?.getModel('dataOcorrencia')?.value,
          acoes: model?.getModel('acoes')?.value,
          riscoId: model?.getModel('risco')?.value?.id,
        })
        .then((result) => {
          const itens = model.getModel('acoes').value;
          const newItens = [...itens, ...result.data];
          model.getModel('acoes').requestChange(newItens);
          model.getModel('planosContingencia').requestChange(value);
        })
        .finally(setIsLoadingAcoes(false));
    }
  }

  function handleSaveConsequenciaRisco(item, handleClose) {
    const modelConsequencia = model.getModel('consequencias');
    let itens = modelConsequencia.value;
    if (!itens) itens = [];

    if (!itens.find((x) => x.consequencia.id == item.consequencia.id)) {
      let consequencia = {
        id: -1,
        descricao: item.consequencia.descricao,
        consequencia: item.consequencia,
        permissions: { allowDelete: true, allowEdit: true },
      };
      itens.push(consequencia);
    }

    modelConsequencia.requestChange(itens);

    handleClose();
  }

  return (
    <Tabs>
      <Tab label={intl.formatMessage({ id: 'cadastro' })}>
        <Row>
          <Col md={12}>
            <PanelCollapse
              header={capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.informacoesBasicas' })
              )}
            >
              <Row className="mx-0">
                {exibirIdIntegracao && (
                  <Col md={2}>
                    <Input
                      style={{ height: '33px' }}
                      disabled={
                        isDisabled ||
                        (utilizarCodigoAutomaticoEventoRisco &&
                          !isNew &&
                          !permitirAlterarCodigoAutomaticoEventoRisco)
                      }
                      maxLength={300}
                      required={!utilizarCodigoAutomaticoEventoRisco || !isNew}
                      model={model.getModel('idIntegracao')}
                    />
                  </Col>
                )}
                <Col md={2}>
                  <DatePicker
                    disabled={isDisabled}
                    timeFormat={false}
                    model={model.getModel('dataOcorrencia')}
                    required={true}
                  />
                </Col>
                <Col md={exibirIdIntegracao ? 6 : 8}>
                  <Input
                    disabled={isDisabled}
                    model={model.getModel('descricao')}
                    required
                    maxLength={1000}
                  />
                </Col>
                <Col md={2} className="d-flex align-items-center">
                  <ArquivoUploadAnexos
                    classNameFormGroup={'d-flex inline'}
                    formGroupStyle={{ marginBottom: 0 }}
                    onlyRead={isDisabled}
                    tipoAnexo={ENTIDADE_ANEXOS.EVENTO_RISCO}
                    rightLabel={true}
                    model={{
                      label: intl.formatMessage({ id: 'anexo' }),
                      value: model.getModel('arquivos').value,
                      requestChange: model.getModel('arquivos').requestChange,
                    }}
                  />
                </Col>
              </Row>
              <Col md={12}>
                <ColaboradorLookup
                  disabled={isDisabled}
                  model={model.getModel('responsavel')}
                  required
                />
              </Col>
              {configuracao.utilizarCampoResposta && (
                <Col md={12}>
                  <RespostaOcorrenciaLookup
                    style={{ marginBottom: '10px' }}
                    disabled={isDisabled}
                    model={model.getModel('respostaOcorrencia')}
                    required={configuracao.definicaoRespostaObrigatorio}
                  />
                </Col>
              )}
              <Col md={12}>
                <Input
                  disabled={isDisabled}
                  type="textarea"
                  model={model.getModel('detalhamentoOcorrencia')}
                  rows={3}
                  maxLength={4000}
                />
              </Col>
            </PanelCollapse>
          </Col>
          {(configuracao.avaliarImpacto ||
            configuracao.avaliarImpactoFinanceiroOcorrencia) && (
            <Col md={12}>
              <PanelCollapse
                header={capitalizeFirstLetter(
                  intl.formatMessage({
                    id: 'avaliacaoImpactoOcorrencia',
                  })
                )}
              >
                <LoadingContainer isLoading={isLoadingSeveridade}>
                  <Row>
                    {configuracao.avaliarImpacto &&
                      tiposSeveridade &&
                      tiposSeveridade?.map(
                        (tipo) =>
                          (!tipo.excluido ||
                            getValueSeveridade(severidadeModelName, tipo)) && (
                            <Col md={12} key={tipo.id}>
                              <SeveridadeRiscoLookup
                                disabled={isDisabled}
                                clearable
                                model={{
                                  label: (
                                    <span>
                                      {capitalizeFirstLetter(tipo.nome)}
                                      <Info
                                        id={`${infoSeveridadeName}-${tipo.id}`}
                                        tooltipMaxWidth={600}
                                        renderContent={() =>
                                          renderDescricaoArraySeveridade(tipo)
                                        }
                                      />
                                    </span>
                                  ),
                                  value: getValueSeveridade(
                                    severidadeModelName,
                                    tipo
                                  ),
                                  requestChange: (value) =>
                                    requestChangeSeveridade(value, tipo),
                                  errors:
                                    model.getModel(severidadeModelName).errors,
                                }}
                                options={itensLookupSeveridade}
                              />
                            </Col>
                          )
                      )}
                    {configuracao.avaliarImpacto && (
                      <Col md={12}>
                        <SeveridadeRiscoLookup
                          disabled={isDisabled}
                          model={{
                            label: capitalizeFirstLetter(
                              intl.formatMessage(
                                { id: 'labelSeveridadeInerente' },
                                { severidade: resources.severidade }
                              )
                            ),
                            value: model.getModel('severidade').value,
                            requestChange:
                              model.getModel('severidade').requestChange,
                            errors: model.getModel('severidade').errors,
                          }}
                        />
                      </Col>
                    )}
                    {configuracao.avaliarImpactoFinanceiroOcorrencia && (
                      <Col md={12}>
                        <InputNumber
                          customClassNameLabel={'control-label pb-1'}
                          disabled={isDisabled}
                          model={{
                            label: capitalizeFirstLetter(
                              `${intl.formatMessage({
                                id: 'labelImpactoFinanceiro',
                              })}`
                            ),
                            value: model.getModel('impactoFinanceiro').value,
                            requestChange:
                              model.getModel('impactoFinanceiro').requestChange,
                          }}
                        />
                      </Col>
                    )}
                    <Col md={10}>
                      <Input
                        disabled={isDisabled}
                        type="textarea"
                        model={model.getModel('comentario')}
                        rows={3}
                        maxLength={1500}
                      />
                    </Col>
                    <Col md={2} className="d-flex align-items-center">
                      <ArquivoUploadAnexos
                        tipoAnexo={ENTIDADE_ANEXOS.EVENTO_RISCO_AVALIACAO}
                        classNameFormGroup={'d-flex inline'}
                        formGroupStyle={{ marginBottom: 0 }}
                        rightLabel={true}
                        model={model.getModel('arquivosAvaliacao')}
                      />
                    </Col>
                  </Row>
                </LoadingContainer>
              </PanelCollapse>
            </Col>
          )}
          <Col md={12}>
            <Row>
              {model.getModel('camposCustomizados').value &&
                model.getModel('camposCustomizados').value.length > 0 && (
                  <Col md={12}>
                    <PanelCollapse
                      header={capitalizeFirstLetter(
                        intl.formatMessage({
                          id: 'informacoesComplementares',
                        })
                      )}
                    >
                      <DesenharCampoCustomizado
                        model={{
                          label: intl.formatMessage({
                            id: 'informacoesComplementares',
                          }),
                          value: model.getModel('camposCustomizados').value,
                          requestChange:
                            model.getModel('camposCustomizados').requestChange,
                        }}
                      />
                    </PanelCollapse>
                  </Col>
                )}
            </Row>
          </Col>
          {configuracao.avaliarCausasOrigemOcorrencia && (
            <Col md={6}>
              <PanelCollapse
                open={true}
                header={capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'labelCausasDoRisco' },
                    {
                      pontosproblematicos: resources.pontosproblematicos,
                      risco: resources.risco,
                    }
                  )
                )}
              >
                <CausasEventoRisco
                  model={model.getModel('causas')}
                  handleSave={handleSaveCausaRisco}
                  onDeleting={handleDeleteCausaRisco}
                  disabled={isDisabled}
                />
              </PanelCollapse>
            </Col>
          )}
          {configuracao.avaliarConsequenciasOcorrencia && (
            <Col md={6}>
              <PanelCollapse
                open={true}
                header={capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'labelConsequenciasDoRisco' },
                    {
                      consequencias: resources.consequencias,
                      risco: resources.risco,
                    }
                  )
                )}
              >
                <ConsequenciasEventoRisco
                  model={model.getModel('consequencias')}
                  handleSave={handleSaveConsequenciaRisco}
                  onDeleting={handleDeleteConsequenciaRisco}
                  disabled={isDisabled}
                />
              </PanelCollapse>
            </Col>
          )}
        </Row>
        {exibirSecaoPlanoAcao && (
          <Row>
            <Col md={12}>
              <PanelCollapse
                header={
                  criarPlanoDeAcaoRespostaOcorrencia
                    ? `${intl.formatMessage(
                        { id: 'labelPlanoAcao' },
                        { acao: resources.acao }
                      )} ${tornarDefinicaoPlanoDeAcaoObrigatoria ? ' *' : ''}`
                    : capitalizeFirstLetter(
                        intl.formatMessage({ id: 'labelPlanosContigencia' })
                      )
                }
              >
                {habilitarPlanoContigencia && (
                  <Row>
                    <Col md={12}>
                      <PlanoContingenciaLookup
                        disabled={isDisabled}
                        multi
                        model={{
                          label: capitalizeFirstLetter(
                            `${intl.formatMessage({
                              id: 'labelPlanoContigencia',
                            })}`
                          ),
                          value: model.getModel('planosContingencia').value,
                          requestChange: requestChangePlanoContingencia,
                        }}
                        data={parameters}
                        parameters={parameters}
                      />
                    </Col>
                  </Row>
                )}
                {criarPlanoDeAcaoRespostaOcorrencia && (
                  <Row>
                    <Col md={12}>
                      <LoadingContainer isLoading={isLoadingAcoes}>
                        <AcaoView
                          local={true}
                          kanban={false}
                          iconSettings={false}
                          handleSave={handleChange}
                          hideHeader={true}
                          hideSearch={true}
                          showBackButton={false}
                          showExport={false}
                          afterRemove={afterRemove}
                          ignoreStickyHeader={true}
                          ignoreTour={true}
                          parameters={{
                            itemId: model?.getModel('risco')?.value?.id,
                            eventoRiscoId: model?.getModel('id')?.value,
                            exibirLookups: false,
                            itemNaoObrigatorio: true,
                          }}
                          dataSource={model?.getModel('acoes')?.value}
                          showRequired={model?.getModel('acoes')?.errors}
                          itemIdOrigin={model?.getModel('risco')?.value?.id}
                          onVincularAcaoSuccess={handleVincularAcaoSucesso}
                        />
                      </LoadingContainer>
                    </Col>
                  </Row>
                )}
              </PanelCollapse>
            </Col>
          </Row>
        )}
        <Row>
          {configuracao.permitirEnvioComunicados && (
            <Col md={12}>
              <PanelCollapse
                open={true}
                header={capitalizeFirstLetter(
                  intl.formatMessage({ id: 'comunicados' })
                )}
              >
                <ComunicadoEventoRisco
                  model={model.getModel('comunicados')}
                  handleSave={handleChangeComunicado}
                  onDeleting={handleDeleteComunicado}
                  disabled={isDisabled}
                  eventoRiscoId={model?.getModel('id')?.value}
                  eventoRiscoDescricao={model?.getModel('descricao')?.value}
                />
              </PanelCollapse>
            </Col>
          )}
        </Row>
        {!isNew && (
          <PanelCollapse
            open={false}
            header={intl.formatMessage({ id: 'label.historico' })}
            loadChildrenOnOpen={true}
          >
            <Historico
              url={`/EventoRisco/ObterHistorico`}
              id={model.getModel('id').value}
            />
          </PanelCollapse>
        )}
      </Tab>
      {model?.getModel('id')?.value > 0 && (
        <Tab label={intl.formatMessage({ id: 'labelComiteCrise' })}>
          <Reuniao
            parameters={{ eventoRiscoId: model.getModel('id')?.value }}
            showOnlyList={true}
          />
        </Tab>
      )}
    </Tabs>
  );
}

function EventoRiscoEditView({ configuracao: configuracaoProp, ...rest }) {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [configuracao, setConfiguracao] = useState(configuracaoProp ?? null);
  const [configuracaoRisco, setConfiguracaoRisco] = useState(null);

  useEffect(() => {
    if (!configuracaoProp) {
      getConfiguration('EventoRiscoConfiguracao')((config) =>
        setConfiguracao(config)
      )();
    }
  }, []);

  useEffect(() => {
    getConfiguration('ItemConfiguracaoRisco')((config) =>
      setConfiguracaoRisco(config)
    )();
  }, []);

  if (!configuracao || !configuracaoRisco) {
    return <LoadingContainer isLoading />;
  }

  return (
    <Edit
      respeitarAltura
      url="/EventoRisco"
      title={intl.formatMessage(
        { id: 'eventosRisco' },
        { eventosderisco: resources.eventosderisco }
      )}
      formComponent={FormEdit}
      schema={Schema}
      showSaveClose
      width="80%"
      minHeight="60%"
      maxHeight="90%"
      {...rest}
      configuracao={configuracao}
      configuracaoRisco={configuracaoRisco}
    ></Edit>
  );
}

export default EventoRiscoEditView;
